/**
 * A6 — shared helper for the Feedback Library bulk actions. Notes and
 * Clips both fan out N idempotent per-id calls (library volumes are
 * tens of rows) and report how many succeeded; the calling hook
 * invalidates the scope ONCE after the batch settles.
 */

/** How many of the N targets succeeded vs. failed (for toast copy). */
export type BulkResult = { ok: number; failed: number };

export async function settleBulk(
  ids: number[],
  op: (id: number) => Promise<unknown>,
): Promise<BulkResult> {
  const results = await Promise.allSettled(ids.map((id) => op(id)));
  const ok = results.filter((r) => r.status === "fulfilled").length;
  return { ok, failed: results.length - ok };
}
